<div class="AdWithUs container">
  <div class="row py-5">
    <div class="col-md-12 mb-4" style="text-align: center;"><h3>Advertise with Wickedlist to reach potential customers for your business.</h3></div>
    <div class="col-2"></div>
    <div class="col-3 text-center border rounded py-4">
      <h2 class="mt-2">Add Your Banner !</h2>
      <h3 class="primary">399$</h3>
      <p>Your banner will be on the site for a month, and during that time, you will get unlimited clicks for a flat fee of 399$. Banner will be located in random spots: on the main page, between the ads, or inside the ads.</p>
      <a routerLink="/buy-baner" class="mt-3" mat-flat-button color="primary">
              Buy now !
      </a>
    </div>
    <div class="col-2"></div>
    <div class="col-3 text-center border rounded py-4">
      <h2 class="mt-2">Add new Sponsored Ad</h2>
      <h3 class="primary">3rd Party Ad</h3>
      <p>
        
        Add your third party ad, 99$ per month
      </p>
      <a routerLink="/buy-third-party" class="mt-3" mat-flat-button color="primary">
        Add now !
      </a>
    </div>
    <div class="col-2"></div>
  </div>
</div>
